import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import PreForeclosure from "@/components/site/PreForeclosure";
import SurplusFunds from "@/components/site/SurplusFunds";
import SellFast from "@/components/site/SellFast";
import Process from "@/components/site/Process";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import AgentPartners from "@/components/site/AgentPartners";
import CashBuyers from "@/components/site/CashBuyers";
import Wholesalers from "@/components/site/Wholesalers";
import VeteranHousing from "@/components/site/VeteranHousing";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import CTABand from "@/components/site/CTABand";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-[#FAF9F6] min-h-screen">
      {/* SEO: Screen-reader-only H1 with brand keyword. Visible H1 is the marketing headline in Hero (H1 tag). */}
      <h1 className="sr-only">
        Clear Path Home Relief Services — Nationwide Foreclosure Help,
        Surplus Funds Recovery, and Sell Your House Fast for Cash. Text 706-506-3860.
      </h1>
      <Header />
      <Hero />
      <Services />
      <PreForeclosure />
      <SurplusFunds />
      <SellFast />
      <Process />
      <WhyChooseUs />
      <AgentPartners />
      <CashBuyers />
      <Wholesalers />
      <VeteranHousing />
      <Testimonials />
      <FAQ />
      <CTABand />
      <Footer />
    </main>
  );
}
